// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.category-view-container {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding: 5%;
}

.selected-view-container {
  flex-direction: column;
  flex: 1;
  margin-left: 5%;
}

.category-view {
  height: 640px;
  width: 360px;
  border: 2px solid black;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background: #f2f2f2;
}

.create-but {
  background: #9F2089;
  color: white;
  font-weight: bold;
  letter-spacing: 1px;
  /* border-radius: ; */
}

.display {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.add-modal-container {
  width: 60%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1%;
  border-radius: 1%;
}

.category-tabs-container {
  display: flex;
  flex-direction: column;
  overflow: scroll;
}

.category-tab {
  width: 60px;
  padding: 5px 0;
  border: 1px solid green;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  cursor: pointer;
}

.category-tileview-container {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  flex: 1;
}

.category-tab-icon {
  width: 40px;
  height: 40px;
}

.tab-title {
  font-size: 10px;
  text-align: center;
  align-self: center;
}

.tile-section {
  margin: 10px;
  background: white;
}

.level-title {
  font-size: 14px;
  font-weight: bold;
  margin: 10px;
  cursor: pointer;
}

.tile-group-container {
  display: grid;
  grid-template-columns: auto auto auto;
}

.tile-container {
  margin: 10px;
  width: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.selected {
  border: 3px solid orange !important;
}

.cat-param-inp {
  margin: 1%;
  padding: 1%;
  font-size: 18px;
  border-radius: 1%;
}

.mod-but {
  margin-top: 2%;
}

.select-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  border: 1px solid green;
  padding: 4%;
  text-align: center;
}

.del-but {
  margin: 1% 2%;
  font-weight: bold;
  color: white;
  background: rgb(236, 100, 100);
}

.ed-but {
  background: orange;
  margin: 1%;
  font-weight: bold;
  color: white;
}

.errd {
  border: 3px solid red;
}

.err-txt {
  color: red;
}

.tree-item {
  border: 1px solid rgb(29, 126, 236);
  cursor: pointer;
  padding: 2%;
  margin: 1% 0;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.dest-data-container {
  width: 100%;
  margin: 5%;
}

.catalog-search-input {
  margin-right: 12px;
}

.select-clp {
  height: 25px;
}
`, "",{"version":3,"sources":["webpack://./client/components/dashboard/CategoryNavigation/CategoryTreeEditor/treeEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,OAAO;EACP,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".page-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.category-view-container {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  padding: 5%;\n}\n\n.selected-view-container {\n  flex-direction: column;\n  flex: 1;\n  margin-left: 5%;\n}\n\n.category-view {\n  height: 640px;\n  width: 360px;\n  border: 2px solid black;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  background: #f2f2f2;\n}\n\n.create-but {\n  background: #9F2089;\n  color: white;\n  font-weight: bold;\n  letter-spacing: 1px;\n  /* border-radius: ; */\n}\n\n.display {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.add-modal-container {\n  width: 60%;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1%;\n  border-radius: 1%;\n}\n\n.category-tabs-container {\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n}\n\n.category-tab {\n  width: 60px;\n  padding: 5px 0;\n  border: 1px solid green;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: white;\n  cursor: pointer;\n}\n\n.category-tileview-container {\n  display: flex;\n  flex-direction: column;\n  overflow: scroll;\n  flex: 1;\n}\n\n.category-tab-icon {\n  width: 40px;\n  height: 40px;\n}\n\n.tab-title {\n  font-size: 10px;\n  text-align: center;\n  align-self: center;\n}\n\n.tile-section {\n  margin: 10px;\n  background: white;\n}\n\n.level-title {\n  font-size: 14px;\n  font-weight: bold;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.tile-group-container {\n  display: grid;\n  grid-template-columns: auto auto auto;\n}\n\n.tile-container {\n  margin: 10px;\n  width: 60px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.selected {\n  border: 3px solid orange !important;\n}\n\n.cat-param-inp {\n  margin: 1%;\n  padding: 1%;\n  font-size: 18px;\n  border-radius: 1%;\n}\n\n.mod-but {\n  margin-top: 2%;\n}\n\n.select-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  flex: 1;\n  border: 1px solid green;\n  padding: 4%;\n  text-align: center;\n}\n\n.del-but {\n  margin: 1% 2%;\n  font-weight: bold;\n  color: white;\n  background: rgb(236, 100, 100);\n}\n\n.ed-but {\n  background: orange;\n  margin: 1%;\n  font-weight: bold;\n  color: white;\n}\n\n.errd {\n  border: 3px solid red;\n}\n\n.err-txt {\n  color: red;\n}\n\n.tree-item {\n  border: 1px solid rgb(29, 126, 236);\n  cursor: pointer;\n  padding: 2%;\n  margin: 1% 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.dest-data-container {\n  width: 100%;\n  margin: 5%;\n}\n\n.catalog-search-input {\n  margin-right: 12px;\n}\n\n.select-clp {\n  height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
